/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './component_details';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "Component": {
                "fields": {
                  "type": {
                    "type": "squareup.connect.v2.Component.ComponentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applicationDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.ApplicationDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardReaderDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.CardReaderDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "batteryDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.BatteryDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "wifiDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.WiFiDetails",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ethernetDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.EthernetDetails",
                    "id": 6,
                    "rule": "optional"
                  },
                  "printerDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.PrinterDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "scaleDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.ScaleDetails",
                    "id": 8,
                    "rule": "optional"
                  },
                  "barcodeScannerDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.BarcodeScannerDetails",
                    "id": 9,
                    "rule": "optional"
                  },
                  "usbInterfaceDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.USBInterfaceDetails",
                    "id": 10,
                    "rule": "optional"
                  },
                  "bluetoothInterfaceDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.BluetoothInterfaceDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "networkInterfaceDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.NetworkInterfaceDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "airprintInterfaceDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.AirPrintInterfaceDetails",
                    "id": 13,
                    "rule": "optional"
                  },
                  "cellularDataDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.CellularDataDetails",
                    "id": 14,
                    "rule": "optional"
                  },
                  "standDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.StandDetails",
                    "id": 15,
                    "rule": "optional"
                  },
                  "scannerScaleDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.ScannerScaleDetails",
                    "id": 16,
                    "rule": "optional"
                  },
                  "internalScannerDetails": {
                    "type": "squareup.connect.v2.DeviceComponentDetails.InternalScannerDetails",
                    "id": 17,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ComponentType": {
                    "values": {
                      "COMPONENT_INVALID_TYPE": 0,
                      "APPLICATION": 1,
                      "CARD_READER": 2,
                      "BATTERY": 3,
                      "WIFI": 4,
                      "ETHERNET": 5,
                      "PRINTER": 6,
                      "SCALE": 7,
                      "BARCODE_SCANNER": 8,
                      "USB_INTERFACE": 9,
                      "BLUETOOTH_INTERFACE": 10,
                      "NETWORK_INTERFACE": 11,
                      "AIRPRINT_INTERFACE": 12,
                      "AUDIO_INTERFACE": 13,
                      "CELLULAR_DATA": 14,
                      "STAND": 15,
                      "SCANNER_SCALE": 16,
                      "INTERNAL_SCANNER": 17
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.Component && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.Component?.nested?.ComponentType) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc The wrapper object for the component entries of a given component type.
 * --
 *
 * SOURCE Component @ squareup/devices/external/component.proto at 16:1
 */
export const Component = $root.lookupType('squareup.connect.v2.Component');
fixType(Component, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(Component);
/**
 * --
 * @desc An enum for ComponentType.
 * --
 *
 * SOURCE ComponentType @ squareup/devices/external/component.proto at 22:3
 */
Component.ComponentType = $root.lookupEnum('squareup.connect.v2.Component.ComponentType').values;